import { axios } from "../services/axios";
import Axios from "axios";
import {
  INSPECTION_REQUEST,
  INSPECTOR_SR_DETAILS_API,
  SR_DETAILS_API,
  GET_CRITERIA_API,
  GET_EQUIPMENT_DEVICE_API,
  INSPECTION_UPDATE,
  GET_MACHINE_DATA,
  GET_INSPECTION_SHEET_DATA,
  INSPECTION_SHEET_DATA_UPDATE,
  GET_MACHINE_CONFIG,
  GET_INSPECTION_SHEET_FROM_EQUIPMENT_TYPE,
  UPLOAD_MACHINE_IMAGES,
  GET_MACHINE_IMAGES,
  DELETE_MACHINE_IMAGES,
  GET_LIST_OF_BOOM_JIB_CONSTRUCTION,
  DOWNLOAD_APP_DOCUMENT,
  MACHINE_EXISTS,
  MACHINE_HISTORY
} from "../constants/paths";
import { CheckMachineExistsDTO } from "./interface/inspection";

/**
 * inspectionRequest DTO
 * @export
 * @typedef {inspectionRequestDTO}
 */

export type inspectionRequestDTO = {
  inspection_date_time: String;
  inspection_date: String;
  inspection_time: String;
  job_contact: String;
  // job_location : any;
  job_location_address: String;
  job_location_city: String;
  job_location_comment: String;
  job_location_state: String;
  job_location_zip_code: String;
  // machine_inspect : String;
  // no_machine : Number;
  ordered_by: String;
  po_no: String;
  project_name: String;
  machineData: any;
};

/**
 * inspection Request API Call
 * @param {inspectionRequestDTO} data
 * @returns {Promise<any>}
 */
export const inspectionRequest = (data: inspectionRequestDTO): Promise<any> => {
  return axios.post(INSPECTION_REQUEST, data);
};

/**
 * SrDetailsDTO DTO
 * @export
 * @typedef {SrDetailsDTO}
 */
export type SrDetailsDTO = {
  id: string;
};

/**
 * SrDetails API Call
 * @param {SrDetailsDTO} data
 * @returns {Promise<any>}
 */
export const getSrDetails = (data: SrDetailsDTO): Promise<any> => {
  return axios.get(SR_DETAILS_API + data.id);
};

/**
 * get Criteria API Call
 * @returns {Promise<any>}
 */
export const getCriteriaAPI = (): Promise<any> => {
  return axios.get(GET_CRITERIA_API);
};

/**
 * get Criteria API Call
 * @returns {Promise<any>}
 */
export const getEquipmentDeviceAPI = (): Promise<any> => {
  return axios.get(GET_EQUIPMENT_DEVICE_API);
};

export const updateInspectionAPI = (data): Promise<any> => {
  return axios.patch(`${INSPECTION_UPDATE}`, data);
};

/**
 * get Machine API Call
 * @returns {Promise<any>}
 */
export const getMachineAPI = (id): Promise<any> => {
  return axios.get(`${GET_MACHINE_DATA}/${id}`);
};

/**
 * get Fieldsheet API Call
 * @returns {Promise<any>}
 */
export const getFieldSheetDataAPI = (id): Promise<any> => {
  return axios.get(`${GET_INSPECTION_SHEET_DATA}/${id}`);
};

/**
 * Update Fieldsheet data API Call
 * @returns {Promise<any>}
 */
export const updateFieldSheetDataAPI = (id, data): Promise<any> => {
  return axios.patch(`${INSPECTION_SHEET_DATA_UPDATE}/${id}`, data);
};

/**
 * get machine config API Call
 * @returns {Promise<any>}
 */
export const getDeficiencyMachineAPI = (id): Promise<any> => {
  return axios.get(`${GET_MACHINE_CONFIG}/${id}`);
};

/**
 * get inspection sheet from equipment type module
 * @returns {Promise<any>}
 */
export const getInspectionSheetFromEquipment = (): Promise<any> => {
  return axios.get(`${GET_INSPECTION_SHEET_FROM_EQUIPMENT_TYPE}`);
};

/**
 * InspectorSrDetailsDTO DTO
 * @export
 * @typedef {SrDetailsDTO}
 */
export type InspectorSrDetailsDTO = {
  id: string;
};

/**
 * SrDetails API Call
 * @param {InspectorSrDetailsDTO} data
 * @returns {Promise<any>}
 */
export const getInspectorSrDetails = (
  data: InspectorSrDetailsDTO
): Promise<any> => {
  return axios.get(INSPECTOR_SR_DETAILS_API + data.id);
};

/**
 * Upload machine images API Call
 * @returns {Promise<any>}
 */
export const uploadMachineImagesApiCall = (data, id): Promise<any> => {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  return axios.post(`${UPLOAD_MACHINE_IMAGES}/${id}`, data, config);
};

/**
 * get machine images API Call
 * @returns {Promise<any>}
 */
export const getMachineImagesApiCall = (id): Promise<any> => {
  return axios.get(`${GET_MACHINE_IMAGES}/${id}`);
};

/**
 * delete machine images API Call
 * @returns {Promise<any>}
 */
export const deleteMachineImagesApiCall = (id): Promise<any> => {
  return axios.get(`${DELETE_MACHINE_IMAGES}/${id}`);
};

/**
 * get list of Boom & jib construction
 * @returns {Promise<any>}
 */
export const getListOfBoomJibConstruction = (): Promise<any> => {
  return axios.get(`${GET_LIST_OF_BOOM_JIB_CONSTRUCTION}`);
};

/**
 * download docuement set in zip  API  Call
 * @returns {Promise<any>}
 */
export const downloadAllApi = (id): Promise<any> => {
  return axios.get(`${DOWNLOAD_APP_DOCUMENT}/${id}`, {
    responseType: "arraybuffer", // Set the response type to arraybuffer
  });
};

/**
 * inspection Request API Call
 * @param {CheckMachineExistsDTO} data
 * @returns {Promise<any>}
 */
export const checkMachineExists = (
  data: CheckMachineExistsDTO
): Promise<any> => {
  return axios.post(MACHINE_EXISTS, data);
};


//get machine history
export const getMachineHistoryAPI = async (id : string|number): Promise<any> => {
  return await axios.get(MACHINE_HISTORY + "/" + id,  );
};